import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import './index.scss';
import { Helmet } from 'react-helmet';
import SkipTo from '../common/Tag/SkipTo';
import ToggleSwitch from '../common/ToggleSwitch';
import {
  fetchUserSubscriptionData,
  updateSubscriptions
} from '../../services/Api/DrugInfo';
import Loader from '../common/Loader';
import { AuthContext } from '../../Contexts';
import { COMM_PREFERENCES_TITLE } from '../../constants/defaults';

const CommunicationsPreference = props => {
  const [subscriptionData, setSubscriptionData] = useState({});
  const [toggleStatus, setToggleStatus] = useState([]);
  const [isvalidUser, setIsvalidUser] = useState(true);
  const [loader, setLoader] = useState(false);
  const searchParams = new URLSearchParams(props?.location?.search);
  let userExternalId = searchParams.get('id');
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  useEffect(() => {
    if (isLoggedIn) {
      removeQueryParam('id');
      userExternalId = '';
      setIsvalidUser(false);
    } else {
      if (_.isEmpty(userExternalId)) {
        setSubscriptionData({});
      }
    }
    setInitialData();
  }, [isLoggedIn]);

  const removeQueryParam = param => {
    try {
      const url = new URL(window?.location);
      url?.searchParams?.delete(param);
      window?.history?.replaceState({}, '', url);
    } catch (error) {
      console.log('error while removing userExternalId', error);
    }
  };

  const setInitialData = async () => {
    setLoader(true);
    try {
      let subscriptionList = await fetchUserSubscriptionData(
        userExternalId,
        searchParams.get('preview'),
        userData?.email
      );
      if (!_.isEmpty(subscriptionList)) {
        if (subscriptionList?.error) {
          if (subscriptionList?.error) setIsvalidUser(false);
        } else {
          setSubscriptionData(subscriptionList);
          setToggleStatus(
            subscriptionList?.subscriptions?.map(subscription => {
              return subscription.subscribed;
            })
          );
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoader(false);
    }
  };

  const toggle = async index => {
    let newArr = [...toggleStatus];
    newArr[index - 1] = !toggleStatus[index - 1];
    setToggleStatus(newArr);
    await updateSubscriptions(
      subscriptionData?.subscriptions[index - 1].id,
      !toggleStatus[index - 1],
      !isLoggedIn ? userExternalId : null,
      isLoggedIn ? userData?.email : null
    );
  };

  return (
    <main>
      <Helmet>
        <title>{COMM_PREFERENCES_TITLE}</title>
      </Helmet>
      <div className="mainResources">
        <div className="resourcesTopSection">
          <div className="middleContainer">
            <SkipTo>
              <div className="heading">
                <h1>Communication preferences</h1>
                {userExternalId && !isLoggedIn && (
                  <h2>{subscriptionData?.email}</h2>
                )}
              </div>
            </SkipTo>
          </div>
        </div>

        {loader ? (
          <div className="logOutRow">
            <Loader />
          </div>
        ) : (
          <div className="subscriptions">
            <article>
              {isLoggedIn || isvalidUser ? (
                <>
                  <label>Emails</label>
                  <span>
                    Opt-in or opt-out from receiving emails for different types
                    of communications
                  </span>
                </>
              ) : (
                <p>
                  To manage your subscriptions, log in or click unsubscribe in
                  an email.
                </p>
              )}

              <ul>
                {subscriptionData?.subscriptions?.map((subscription, index) => {
                  return (
                    <li key={index}>
                      <div className="subscriptionsCard">
                        <div className="subscriptionText">
                          <label> {subscription?.name} </label>
                          <span> {subscription?.description} </span>
                        </div>
                        <ToggleSwitch
                          id={index + 1}
                          checked={toggleStatus[index] == true}
                          onChange={toggle}
                        />
                      </div>
                    </li>
                  );
                })}
              </ul>
            </article>
          </div>
        )}
      </div>
    </main>
  );
};
export default CommunicationsPreference;
